const AIFeatures = ({ data }) => {
  if (!data) return null;

  const tooltips = [
    "Think of this as your smart writing assistant! It takes your ideas and turns them into professional documents that you can review and edit.",
    "This is your compliance watchdog! It catches mistakes before they become problems, like having a legal expert looking over your shoulder 24/7.",
    "Say goodbye to messy email chains! This creates an organized submission system where everything is tracked and nothing gets lost.",
    "This explains WHY the AI made each decision. No black boxes here - you can trace everything back to its source!",
    "Your early warning system! It spots potential problems across different areas so you can fix them before they become costly.",
    "Checklists that adapt to your situation! Like having a smart assistant who knows exactly what steps you need for each unique project.",
    "Writer's block? Gone! The AI creates first drafts of summaries and memos that you can polish and personalize.",
    "Never lose track of what needs to be done! It turns findings into actionable tasks with reminders and complete history."
  ];

  return (
    <section className="py-16 px-6" data-testid="ai-features-section">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold mb-4">{data.title}</h2>
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-xl hover:border-purple-300 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
              data-testid={`ai-feature-${index}`}
              data-robot-tooltip={tooltips[index]}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600/10 to-blue-600/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative z-10">
                <h3 className="text-base font-semibold mb-2 text-gray-900">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIFeatures;
